import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import LoadingPage from '../LoadingPage';
import ApiService from '../../services/ApiService';
import ModalList from './ModalList';
import ModalTable from './ModalTable';
// import { popProperty } from '../../util/general';

const keymap = r => Object.keys(r).map(k => r[k]);

const operationHeaders = [
  {
    text: 'Opr',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Labor',
    width: 80,
    maxWidth: 80,
    className: 'text-center',
  },
  {
    text: 'Details',
    flex: 1,
    autoHeight: true,
    wrapText: true,
    className: 'cell-wrap',
  },
];

const partHeaders = [
  {
    text: 'Opr',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Line #',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Qty',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Division',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Part #',
    minWidth: 100,
    flex: 2,
  },
  {
    text: 'Description',
    minWidth: 75,
    flex: 1,
  },
  {
    text: 'Initials',
    width: 75,
    className: 'text-center',
    cellStyle: { textTransform: 'uppercase' },
  },
  {
    text: 'Trade',
    width: 85,
    className: 'text-right',
    type: 'currencyColumn',
  },
  {
    text: 'Net',
    width: 85,
    className: 'text-right',
    type: 'currencyColumn',
  },
  {
    text: 'Ext Sales',
    width: 85,
    className: 'right',
  },
  {
    text: 'Issued',
    width: 85,
    className: 'center',
  },
];

const movedPartHeaders = [
  {
    text: 'Opr',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Line #',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Qty',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Division',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Part #',
    minWidth: 100,
    flex: 2,
  },
  {
    text: 'Description',
    minWidth: 75,
    flex: 1,
  },
  {
    text: 'Initials',
    width: 75,
    className: 'text-center',
    cellStyle: { textTransform: 'uppercase' },
  },
  {
    text: 'Move Date',
    width: 100,
    className: 'text-center',
  },
  {
    text: 'Moved By',
    width: 100,
    className: 'text-center',
    cellStyle: { textTransform: 'uppercase' },
  },
  {
    text: 'Moved To',
    width: 100,
    className: 'text-center',
  },
];

const laborHeaders = [
  {
    text: 'Tech #',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Name',
    minWidth: 120,
    flex: 1,
  },
  {
    text: 'Opr',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Line',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Date',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Time',
    width: 75,
    className: 'text-center',
  },  
  {
    text: 'Hours',
    width: 75,
    className: 'text-right',
  },
  {
    text: 'Overtime',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Total',
    width: 75,
    className: 'text-right',
    type: 'currencyColumn',
  },
];

const statusHeaders = [
  {
    text: 'Type',
    width: 95,
    className: 'text-center',
  },
  {
    text: 'Date',
    width: 95,
    className: 'text-center',
  },
  {
    text: 'Time',
    width: 95,
    className: 'text-center',
  },
  {
    text: 'Changed From',
    width: 155,
    flex: 1,
    className: 'text-center',
  },
  {
    text: 'Changed To',
    width: 155,
    flex: 2,
    className: 'text-center',
  },
  {
    text: 'Changed By',
    width: 135,
    className: 'text-center',
  },
  {
    text: 'Screen',
    width: 105,
    className: 'text-center',
  },
];

const removedLaborHeaders = [
  {
    text: 'Tech #',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Name',
    minWidth: 120,
    flex: 1,
  },
  {
    text: 'Opr',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Line',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Date',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Time',
    width: 75,
    className: 'text-center',
  },   
  {
    text: 'Hours',
    width: 75,
    className: 'text-right',
  },
  {
    text: 'Overtime',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Removed By',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Removed On',
    width: 75,
    className: 'text-center',
  },
];

const historyHeaders = [
  {
    text: 'Closed By',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Date Closed',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Time Closed',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Reopened By',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Date Reopened',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Time Reopened',
    width: 75,
    className: 'text-center',
  },
  {
    text: 'Reopen Reason',
    width: 255,
  },
];

const RepairHistory = ({ lookupKey, view }) => {
  const [loading, setLoading] = useState(true);
  const [primaryData, setPrimaryData] = useState({});

  const getData = () => {
    setLoading(true);

    ApiService.get(`drilldown/${view}/${encodeURIComponent(lookupKey)}`)
      .then(response => {
        const { data } = response.data;

        let specs;
        try {
          specs = JSON.parse(data) || {};
        } catch (err) {
          console.warn('Parse failed', err);
        }

        if (!specs) {
          return;
        }

        specs.history = specs.history ? specs.history.map(keymap) : [];
        specs.operations = specs.operations ? specs.operations.map(keymap) : [];
        specs.labor = specs.labor ? specs.labor.map(keymap) : [];
        specs.removedLabor = specs.removedLabor ? specs.removedLabor.map(keymap) : [];
        specs.parts = specs.parts ? specs.parts.map(keymap) : [];
        specs.movedParts = specs.movedParts ? specs.movedParts.map(keymap) : [];
        specs.status = specs.status ? specs.status.map(keymap) : [];

        setPrimaryData(specs);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  // TODO Include Notes also?
  // const [notesString] = popProperty(primaryData.details, 'Notes');
  // const expandedNotes = notesString.split('\n');
  // const notes = [];

  // for (let i = 0; i < expandedNotes.length; i++) {
  //   if (0 || i % 3 === 0) {
  //     notes.push({ date: expandedNotes[i], author: expandedNotes[i + 1], msg: expandedNotes[i + 2] });
  //   }
  // }

  return (
    <div>
      <Row>
        <Col md={12}>
          <ModalList data={primaryData.details} columns={2} />
          {/* {notes.map(note => <div>Date {note.date} | Author {note.author} | Msg {note.msg}</div>)} */}
        </Col>
      </Row>

      <Row>
        <Col md={12} lg={12} xl={12}>
          <div className="h5 mb-0 mt-2 p-1">History</div>
          <hr className="mt-0 mb-2" />
          <ModalTable hideToolbar headers={historyHeaders} data={primaryData.history} style={{ height: '100px' }} />
        </Col>
      </Row>

      <Row>
        <Col md={12} lg={12} xl={12}>
          <div className="h5 mb-0 mt-2 p-1">Operations</div>
          <hr className="mt-0 mb-2" />
          <ModalTable
            hideToolbar
            headers={operationHeaders}
            data={primaryData.operations}
            style={{ height: '200px' }}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12} lg={12} xl={12}>
          <div className="h5 mb-0 mt-2 p-1">Parts</div>
          <hr className="mt-0 mb-2" />
          <ModalTable hideToolbar headers={partHeaders} data={primaryData.parts} style={{ height: '250px' }} />
        </Col>
      </Row>

      <Row>
        <Col md={12} lg={12} xl={12}>
          <div className="h5 mb-0 mt-2 p-1">Moved Parts</div>
          <hr className="mt-0 mb-2" />
          <ModalTable
            hideToolbar
            headers={movedPartHeaders}
            data={primaryData.movedParts}
            style={{ height: '250px' }}
          />
        </Col>
      </Row>

      <Row>
        <Col xl={12} lg={12}>
          <div className="h5 mb-0 mt-2 p-1">Labor</div>
          <hr className="mt-0 mb-2" />
          <ModalTable hideToolbar headers={laborHeaders} data={primaryData.labor} style={{ height: '250px' }} />
        </Col>
      </Row>
      <Row>
        <Col xl={12} lg={12}>
          <div className="h5 mb-0 mt-2 p-1">Removed Labor</div>
          <hr className="mt-0 mb-2" />
          <ModalTable
            hideToolbar
            headers={removedLaborHeaders}
            data={primaryData.removedLabor}
            style={{ height: '250px' }}
          />
        </Col>
      </Row>
      <Row>
        <Col xl={12} lg={12}>
          <div className="h5 mb-0 mt-2 p-1">Status</div>
          <hr className="mt-0 mb-2" />
          <ModalTable
            hideToolbar
            headers={statusHeaders}
            data={primaryData.status}
            style={{ height: '250px' }}
          />
        </Col>
      </Row>
    </div>
  );
};

RepairHistory.propTypes = {
  lookupKey: PropTypes.string,
  view: PropTypes.string,
};

export default RepairHistory;
